import * as Types from 'src/state/gql/_types';
import { AsyncAction } from 'src/state/_types';
import { handleGraphqQLErrorResponse, } from 'src/state/gql/utils';

export const createThread: AsyncAction<Types.CreateThreadWithMessageMutationVariables,Types.CreateThreadWithMessageMutation['item']> = async ({state, effects}, payload) => {
    state.threads.errors = [];
    try {
        let { item } = await effects.gql.mutations.CreateThreadWithMessage(payload);
        return item;
    } catch (e: any) {
        state.threads.errors = handleGraphqQLErrorResponse(e);
        return null;
    }
}

export const markThreadRead: AsyncAction<Types.MarkThreadReadMutationVariables, Types.MarkThreadReadMutation['item']> = async ({ state, effects }, payload) => {
    state.threads.errors = [];
    try {
        let { item } = await effects.gql.mutations.MarkThreadRead(payload);
        return item;
    } catch (e: any) {
        state.threads.errors = handleGraphqQLErrorResponse(e);
        return null;
    }
}

export const createThreadWithMessage: AsyncAction<Partial<Types.CreateThreadWithMessageMutationVariables>,Types.CreateThreadWithMessageMutation['item']> = async ({state,effects}, payload)=> {
    state.threads.errors = [];
    try {
        let { item } = await effects.gql.mutations.CreateThreadWithMessage(payload as Types.CreateThreadWithMessageMutationVariables);
        return item; 
    } catch (error: any) {
        state.threads.errors = handleGraphqQLErrorResponse(error);
        return null
    }
}